import { Component, Input } from '@angular/core';

declare var $: any;

@Component({
    selector: 'itpx-pagebase-tile',
    templateUrl: './component.html',
    styleUrls: ['./component.css']
})
export class PageBaseTileComponent {
    @Input() target: Array<any> = [];
    @Input() adaptive: boolean = false;

    constructor(
    ) { }

}


// WEBPACK FOOTER //
// ./src/app/core/components/partials/pagebasetile/component.ts